import { render, staticRenderFns } from "./TopSearches.vue?vue&type=template&id=67a0cfdb&scoped=true&"
import script from "./TopSearches.vue?vue&type=script&lang=ts&"
export * from "./TopSearches.vue?vue&type=script&lang=ts&"
import style0 from "./TopSearches.vue?vue&type=style&index=0&id=67a0cfdb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a0cfdb",
  null
  
)

export default component.exports